import { apiClient } from './api'

/** Forecast breakdown computed by backend/app/services/forecast.py. */
export interface ForecastDetails {
  method?: string
  planned_end?: string | null
  plan_finish?: string | null
  pace_finish?: string | null
  progress_percent?: number
  throughput_hours_per_week?: number
  completed_last_8_weeks?: number
  open_tasks?: number
  remaining_hours?: number
  projects?: number
  cost?: { budget: number | null; spent: number; eac?: number | null; eac_low?: number | null; eac_high?: number | null; cpi?: number | null; spi?: number | null; variance?: number | null }
  drivers?: Array<{ kind: string; text: string }>
  scenarios?: Array<{ name: string; finish: string | null; days_saved: number }>
  critical_path_open?: string[]
  explanation?: { summary: string; drivers: string[]; recommendations: Array<{ action: string; why: string }> }
  completion_date_low?: string | null
  completion_date_high?: string | null
  budget_low?: number | null
  budget_high?: number | null
  ai_powered?: boolean
}

export interface ResourceNeed { role: string; fte: number; weeks: number; reason: string; hours?: number; user_id?: number }

export interface PredictionRow {
  id: number
  entity_type: string
  entity_id: number
  type: 'completion_date' | 'budget' | 'resource_needs'
  metric: string
  predicted_value: string
  confidence: number | null
  period: string | null
  created_at: string
  details?: ForecastDetails | null
}

export interface PredictionBundle {
  entity_type: string
  entity_id: number
  completion_date?: string | null
  completion_date_low?: string | null
  completion_date_high?: string | null
  completion_date_confidence?: number | null
  budget_at_completion?: number | null
  budget_low?: number | null
  budget_high?: number | null
  budget_confidence?: number | null
  resource_needs?: ResourceNeed[]
  details?: ForecastDetails
  generated_at: string
  ai_powered: boolean
}

export interface ForecastAccuracy {
  completion_date: { scored: number; hit?: number; near?: number; miss?: number; mean_abs_error?: number | null; unit?: string }
  budget: { scored: number; hit?: number; near?: number; miss?: number; mean_abs_error?: number | null; unit?: string }
}

export const aiPredictionsService = {
  async generate(entity_type: string, entity_id: number): Promise<PredictionBundle> {
    const { data } = await apiClient.post<PredictionBundle>('/api/v1/ai/predictions/generate', {
      entity_type,
      entity_id,
    })
    return data
  },

  async list(entity_type?: string, entity_id?: number): Promise<PredictionRow[]> {
    const { data } = await apiClient.get<PredictionRow[]>('/api/v1/ai/predictions', {
      params: { entity_type, entity_id },
    })
    return data
  },

  async accuracy(): Promise<ForecastAccuracy> {
    const { data } = await apiClient.get<ForecastAccuracy>('/api/v1/ai/predictions/accuracy')
    return data
  },
}
